// extracted by mini-css-extract-plugin
export default {"question":"question_question__wq47Z","card":"question_card__dox48","imgList":"question_imgList__ocRW5","handler":"question_handler__PtZ4y"};